import { useMutation } from "@apollo/client";

import { ClientRemoveVoucherDocument } from "../../__generated__/graphql";

export function useRemoveVoucher(invoiceId: string) {
  // The returned invoice updates the detail in cache; list totals and voucher count refetch.
  const [mutate, { loading }] = useMutation(ClientRemoveVoucherDocument, {
    refetchQueries: ["InvoicesByFilters", "ClientViewVouchers"],
  });

  const removeVoucher = () => mutate({ variables: { input: { invoiceId } } });

  return { removeVoucher, loading };
}
